import { createAction, props } from '@ngrx/store';


export const loadPlans = createAction(
  '[Website] Load Plans',
  props<{ plans: any[] }>()
);
